import { createApi } from "@reduxjs/toolkit/query/react";
import { Item, RestaurantResponse } from "../../types";
import { ITEM } from "../../configs";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const itemApi = createApi({
  reducerPath: ITEM.reducerPath,
  baseQuery: createBaseQuery(ITEM.baseUrl),
  tagTypes: ITEM.tagTypes,
  endpoints(builder) {
    return {
      fetchItemsByRestaurant: builder.query<RestaurantResponse, string>({
        query: (restaurantId: string) => {
          return {
            url: "/restaurants/" + restaurantId,
            method: "GET",
          };
        },
      }),
      fetchItemDetails: builder.query<Required<Item>, string>({
        query: (itemId: string) => {
          return {
            url: `/${itemId}/details`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const { useFetchItemsByRestaurantQuery, useFetchItemDetailsQuery } =
  itemApi;

export { itemApi };
